import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Props as DumbPlayerAppearanceProps } from '#src/components/scoring/DumbPlayerAppearance/index.tsx';
import { DumbPlayerAppearance } from '#src/components/scoring/DumbPlayerAppearance/index.tsx';

import type { PlayerAppearance_anyPlayer } from './__generated__/index.graphql.ts';

type Props = {
  player: PlayerAppearance_anyPlayer;
} & Omit<DumbPlayerAppearanceProps, 'appearances'>;

const APPEARANCE_CONFIG: Record<
  Props['mode'],
  { denominator: number; raw: (p: PlayerAppearance_anyPlayer) => number | null }
> = {
  LAST_FIVE_SO5_AVERAGE_SCORE: {
    denominator: 5,
    raw: p => p.lastFiveSo5Appearances,
  },
  LAST_TEN_PLAYED_SO5_AVERAGE_SCORE: {
    denominator: 10,
    raw: p => p.lastTenSo5Appearances,
  },
  LAST_FIFTEEN_SO5_AVERAGE_SCORE: {
    denominator: 15,
    raw: p => p.lastFifteenSo5Appearances,
  },
  LAST_FORTY_SO5_AVERAGE_SCORE: {
    denominator: 40,
    raw: p => p.lastFortySo5Appearances,
  },
};

export const PlayerAppearance = ({ player, mode, ...props }: Props) => {
  const { denominator, raw } = APPEARANCE_CONFIG[mode];
  const appearances = (raw(player) || 0) / denominator;
  return (
    <DumbPlayerAppearance {...props} mode={mode} appearances={appearances} />
  );
};

PlayerAppearance.fragments = {
  anyPlayer: gql`
    fragment PlayerAppearance_anyPlayer on AnyPlayerInterface {
      slug
      lastFiveSo5Appearances(teamMode: $teamMode)
      lastTenSo5Appearances(teamMode: $teamMode)
      lastFifteenSo5Appearances(teamMode: $teamMode)
      lastFortySo5Appearances(teamMode: $teamMode)
    }
  ` as TypedDocumentNode<PlayerAppearance_anyPlayer>,
};
